module.exports = __webpack_public_path__ + "img/header-dashboard.a8fd7693.jpeg";